import { render, staticRenderFns } from "./VenuesEvent.vue?vue&type=template&id=37951f99&"
import script from "./VenuesEvent.vue?vue&type=script&lang=js&"
export * from "./VenuesEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports